var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgValidationVide(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 28,
    viewBox: "0 0 35 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9142 14.5858L27.0858 2.41421C27.8668 1.63317 29.1332 1.63317 29.9142 2.41421L32.5858 5.08579C33.3668 5.86684 33.3668 7.13316 32.5858 7.91421L14.9142 25.5858C14.1332 26.3668 12.8668 26.3668 12.0858 25.5858L2.41421 15.9142C1.63316 15.1332 1.63317 13.8668 2.41421 13.0858L5.08579 10.4142C5.86684 9.63317 7.13316 9.63316 7.91421 10.4142L12.0858 14.5858C12.8668 15.3668 14.1332 15.3668 14.9142 14.5858Z",
    stroke: "#FE5000",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValidationVide);
export default __webpack_public_path__ + "static/media/validation_vide.d729d779.svg";
export { ForwardRef as ReactComponent };